import { useTranslation } from "react-i18next";
import { Form, Input, Button } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useCallback, useState } from "react";
import { setLoginState } from "../../features/login/loginSlice";
import { setLocalStorageData } from "../../shared/commonFunction";
import { login } from "../../services/Api";
import { showToast } from "../../shared/sharedComponents/ToasterMessage/ToasterMessage";
import "./Login.scss";
import { setUser } from "../../features/user/userSlice";

const Login = () => {
  const { t, i18n } = useTranslation("common");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isLogin = useSelector((state) => state.login.isLogin);
  const [isLoading, setIsLoading] = useState(false);

  // Redirect if already logged in
  useEffect(() => {
    console.log('isLogin: ', isLogin);
    if (isLogin) {
      navigate("/");
    }
    window.scrollTo(0, 0);
  }, [isLogin, navigate]);

  // Handle form submission
  const handleLogin = useCallback(async (values) => {
    setIsLoading(true);
    try {
      const response = await login(
        values.email,
        values.password,
        i18n.language
      );
      if (response.success) {
        setLocalStorageData("token", response.token);
        setLocalStorageData("user", JSON.stringify(response.user));
        dispatch(setLoginState(true));
        dispatch(setUser(response.user));
        showToast(response?.message, "success");
        form.resetFields();
        const redirectPath = location.state?.from?.pathname || "/";
        navigate(redirectPath, { replace: true });
        window.scrollTo(0, 0);
      } else {
        showToast(response.message, "error");
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error?.message) {
        showToast(error?.message || error?.response?.data?.message, "error");
      } else {
        showToast(error, "error");
      }

    } finally {
      setIsLoading(false);
    }
  }, [dispatch, form, i18n.language, location.state, navigate, t]);

  return (
    <section className="login-section">
      <div className="login-main-box">
        <div>
          <h1 className="login-heading">{t("signUp.login")}</h1>
        </div>
        <div className="login-up-box">
          <Form
            layout="vertical"
            form={form}
            onFinish={handleLogin}
            style={{ maxWidth: 600, width: "100%" }}
            initialValues={{ prefix: "86" }}
          >
            <Form.Item
              name="email"
              label={t("signUp.email")}
              rules={[
                {
                  type: "email",
                  message: t("signUp.invalidEmail"),
                },
                {
                  required: true,
                  message: t("signUp.requiredField", {
                    field: t("signUp.email"),
                  }),
                },
              ]}
            >
              <Input
                placeholder={t("signUp.emailPlaceholder")}
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label={t("signUp.password")}
              rules={[
                {
                  required: true,
                  message: t("signUp.requiredField", {
                    field: t("signUp.password"),
                  }),
                },
                {
                  min: 6,
                  message: t("signUp.minLengthField", {
                    field: t("signUp.password"),
                    length: 6,
                  }),
                },
              ]}
              hasFeedback
            >
              <Input.Password
                placeholder={t("signUp.passwordPlaceholder")}
                autoComplete="password"
                style={{ backgroundColor: "#141414" }}
              />
            </Form.Item>

            <Link to="/forgot-password">
              <p className="forgot-pass">{t("signUp.forgot_Password")}</p>
            </Link>

            <Form.Item>
              <p style={{ margin: "0 auto", width: "100%", textAlign: "center" }}>
                <Button
                  type="primary"
                  loading={isLoading}
                  htmlType="submit"
                  className="submit-btn"
                >
                  {t("signUp.login")}
                </Button>
              </p>
            </Form.Item>

            <Form.Item style={{ display: "flex", justifyContent: "center" }}>
              <p
                className="signup-here-msg"
                style={{ display: "inline" }}
                dangerouslySetInnerHTML={{
                  __html: t("signUp.noAccount"),
                }}
              ></p><Link to="/sign-up" className="sign-up-here" dangerouslySetInnerHTML={{ __html: t("signUp.signUp") }}></Link>

            </Form.Item>

          </Form>
        </div>
      </div>
    </section>
  );
};

export default Login;
